'use strict';

var _ = require('underscore');

// constructor
function Application(application) {
    _.extend(this, application);

    this.values = {};
    this.errors = {};
    this.tagTextInput = {};

    return this;
}

// methods
_.extend(Application.prototype, {

    setField: function(fieldName, value) {

        // error catch for bad states that may happen with unidropdown
        if (fieldName === "institution" && value === null) {
          value = -1;
        }

        this.values[fieldName] = value;

        if(value === null || value === "" || value === undefined) {
          this.errors[fieldName] = true;
        }
        else if (fieldName === "institution" && value === -1) {
          this.errors[fieldName] = true;
        }
        else if (fieldName === "email" && (value.indexOf('@') === -1 || value.indexOf('.') === -1)){
          this.errors[fieldName] = true;
        }
        else {
          this.errors[fieldName] = false;
        }
    },
    getError: function(fieldName) {
      if(this.errors.hasOwnProperty(fieldName)) {
        return this.errors[fieldName];
      }
      else {
        return true;
      }
    }

});

module.exports = {

    create: function (application) {
        return new Application(application);
    },

    model: Application

};



/*****************
 ** WEBPACK FOOTER
 ** ./js/shared/models/application.js
 ** module id = 257
 ** module chunks = 0 1 6
 **/